import $ from 'jquery';

// toggle side nav mobile
$(".sidenav-mobile-toggle").click(function (e) {
    document.body.classList.toggle("sidenav-mobile-toggle-show");
});